(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function closePopover(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    const toggle = document.querySelector(`[data-pdp-popover-toggle="${panel.id}"]`);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function openPopover(id) {
    const panel = document.getElementById(id);
    if (!panel) return;
    qsa('.pdp-popover.is-open').forEach((el) => {
      if (el !== panel) closePopover(el);
    });
    panel.hidden = false;
    panel.removeAttribute('hidden');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    const toggle = document.querySelector(`[data-pdp-popover-toggle="${id}"]`);
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    // Ignore the same click that opened the panel (outside-close listener).
    panel.dataset.pdpJustOpened = '1';
    setTimeout(() => {
      delete panel.dataset.pdpJustOpened;
    }, 0);
  }

  function togglePopover(id) {
    const panel = document.getElementById(id);
    if (!panel) return;
    if (panel.classList.contains('is-open')) closePopover(panel);
    else openPopover(id);
  }

  function initPopovers() {
    if (document.documentElement.dataset.pdpPopoversInit === '1') return;
    document.documentElement.dataset.pdpPopoversInit = '1';

    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-pdp-popover-toggle]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        togglePopover(toggle.getAttribute('data-pdp-popover-toggle'));
        return;
      }

      const closer = e.target.closest('[data-pdp-popover-close]');
      if (closer) {
        e.preventDefault();
        e.stopPropagation();
        closePopover(closer.closest('.pdp-popover'));
        return;
      }

      qsa('.pdp-popover.is-open').forEach((panel) => {
        if (panel.dataset.pdpJustOpened === '1') return;
        const root = panel.closest('[data-pdp-popover-root]');
        if (root && !root.contains(e.target)) closePopover(panel);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        qsa('.pdp-popover.is-open').forEach(closePopover);
        return;
      }
      const toggle = e.target.closest('[data-pdp-popover-toggle]');
      if (toggle && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        togglePopover(toggle.getAttribute('data-pdp-popover-toggle'));
      }
    });
  }

  // Keep legacy modal helpers for any remaining .pdp-modal markup
  function openModal(id) {
    openPopover(id);
  }
  function closeModal(el) {
    closePopover(el);
  }
  function initModals() {
    initPopovers();
  }

  function initQuotes() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    qsa('[data-pdp-quotes]').forEach((root) => {
      const slides = qsa('.pdp-quotes__slide', root);
      if (slides.length < 2) return;
      let i = 0;

      const show = (n, dir) => {
        const next = (n + slides.length) % slides.length;
        if (next === i) return;
        const direction = dir == null ? (next > i || (i === slides.length - 1 && next === 0) ? 1 : -1) : dir;
        i = next;

        slides.forEach((s, idx) => {
          const on = idx === i;
          s.classList.remove('is-entering', 'is-entering-prev');
          s.classList.toggle('is-active', on);
          if (on && !reduceMotion) {
            void s.offsetWidth;
            s.classList.add(direction < 0 ? 'is-entering-prev' : 'is-entering');
          }
        });
      };

      qs('[data-pdp-quotes-prev]', root)?.addEventListener('click', () => show(i - 1, -1));
      qs('[data-pdp-quotes-next]', root)?.addEventListener('click', () => show(i + 1, 1));
    });
  }

  function initGuideTabs() {
    qsa('[data-pdp-guide]').forEach((root) => {
      const tabs = qsa('[data-pdp-guide-tab]', root);
      const panels = qsa('[data-pdp-guide-panel]', root);
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          if (tab.classList.contains('is-active')) return;
          const id = tab.getAttribute('data-pdp-guide-tab');
          tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          panels.forEach((p) => {
            const on = p.getAttribute('data-pdp-guide-panel') === id;
            p.classList.toggle('is-active', on);
            if (on) {
              p.classList.remove('is-entering');
              void p.offsetWidth;
              p.classList.add('is-entering');
            }
          });
        });
      });
    });
  }

  function initAccordions() {
    const DURATION = 320;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const panelOf = (item) => item.querySelector(':scope > .pdp-acc__panel');

    const clearPanelInline = (panel) => {
      panel.style.height = '';
      panel.style.paddingTop = '';
      panel.style.paddingBottom = '';
      panel.style.overflow = '';
      panel.style.transition = '';
    };

    const stopPanelAnim = (panel) => {
      if (!panel) return;
      if (panel._pdpAccFinish) {
        panel.removeEventListener('transitionend', panel._pdpAccFinish);
        clearTimeout(panel._pdpAccTimer);
        panel._pdpAccFinish = null;
        panel._pdpAccTimer = null;
      }
    };

    const animatePanel = (panel, from, to, onDone) => {
      stopPanelAnim(panel);

      let done = false;
      const finish = (e) => {
        if (done) return;
        if (e && e.target !== panel) return;
        if (e && e.propertyName && e.propertyName !== 'height') return;
        done = true;
        stopPanelAnim(panel);
        onDone();
      };
      panel._pdpAccFinish = finish;

      panel.style.overflow = 'hidden';
      panel.style.boxSizing = 'border-box';
      panel.style.transition = 'none';
      panel.style.height = `${from.height}px`;
      panel.style.paddingTop = `${from.paddingTop}px`;
      panel.style.paddingBottom = `${from.paddingBottom}px`;
      // Force style flush before starting the ease.
      panel.getBoundingClientRect();

      requestAnimationFrame(() => {
        panel.style.transition = [
          `height ${DURATION}ms ease`,
          `padding-top ${DURATION}ms ease`,
          `padding-bottom ${DURATION}ms ease`,
        ].join(', ');
        panel.style.height = `${to.height}px`;
        panel.style.paddingTop = `${to.paddingTop}px`;
        panel.style.paddingBottom = `${to.paddingBottom}px`;
      });

      panel.addEventListener('transitionend', finish);
      panel._pdpAccTimer = window.setTimeout(finish, DURATION + 100);
    };

    const measureOpen = (panel) => {
      const prev = {
        height: panel.style.height,
        paddingTop: panel.style.paddingTop,
        paddingBottom: panel.style.paddingBottom,
        overflow: panel.style.overflow,
        transition: panel.style.transition,
      };
      clearPanelInline(panel);
      const cs = getComputedStyle(panel);
      const metrics = {
        height: panel.getBoundingClientRect().height,
        paddingTop: parseFloat(cs.paddingTop) || 0,
        paddingBottom: parseFloat(cs.paddingBottom) || 0,
      };
      panel.style.height = prev.height;
      panel.style.paddingTop = prev.paddingTop;
      panel.style.paddingBottom = prev.paddingBottom;
      panel.style.overflow = prev.overflow;
      panel.style.transition = prev.transition;
      return metrics;
    };

    const expand = (item) => {
      const panel = panelOf(item);
      item.open = true;
      item.classList.add('is-expanded');
      if (!panel || reduceMotion) {
        clearPanelInline(panel);
        item.dataset.pdpAccAnimating = '0';
        return;
      }
      const end = measureOpen(panel);
      animatePanel(
        panel,
        { height: 0, paddingTop: 0, paddingBottom: 0 },
        end,
        () => {
          clearPanelInline(panel);
          item.dataset.pdpAccAnimating = '0';
        }
      );
    };

    const collapse = (item) => {
      const panel = panelOf(item);
      item.classList.remove('is-expanded');
      if (!panel || reduceMotion) {
        item.open = false;
        clearPanelInline(panel);
        item.dataset.pdpAccAnimating = '0';
        return;
      }
      const cs = getComputedStyle(panel);
      const start = {
        height: panel.getBoundingClientRect().height,
        paddingTop: parseFloat(cs.paddingTop) || 0,
        paddingBottom: parseFloat(cs.paddingBottom) || 0,
      };
      animatePanel(panel, start, { height: 0, paddingTop: 0, paddingBottom: 0 }, () => {
        item.open = false;
        clearPanelInline(panel);
        item.dataset.pdpAccAnimating = '0';
      });
    };

    qsa('.pdp-acc').forEach((root) => {
      if (root.dataset.pdpAccInit === '1') return;
      root.dataset.pdpAccInit = '1';

      qsa('.pdp-acc__item', root).forEach((item) => {
        const summary = item.querySelector(':scope > summary');
        if (!summary) return;
        if (item.open) item.classList.add('is-expanded');

        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.dataset.pdpAccAnimating === '1') return;
          item.dataset.pdpAccAnimating = '1';

          if (item.open) {
            collapse(item);
            return;
          }

          qsa('.pdp-acc__item', root).forEach((other) => {
            if (other !== item && other.open) {
              other.dataset.pdpAccAnimating = '1';
              collapse(other);
            }
          });
          expand(item);
        });
      });
    });
  }

  function initPairCarousel() {
    qsa('[data-pdp-pair]').forEach((root) => {
      const track = qs('[data-pdp-pair-track]', root);
      if (!track) return;
      const cards = Array.from(track.children);
      if (cards.length < 2) return;
      let index = 0;
      const step = () => {
        const card = cards[0];
        const gap = parseFloat(getComputedStyle(track).gap) || 30;
        return card.getBoundingClientRect().width + gap;
      };
      const maxIndex = () => {
        const viewport = track.parentElement;
        if (!viewport) return 0;
        const maxShift = Math.max(0, track.scrollWidth - viewport.clientWidth);
        return Math.max(0, Math.ceil(maxShift / step()));
      };
      const render = () => {
        if (window.matchMedia('(max-width: 767.98px)').matches) {
          track.style.transform = '';
          return;
        }
        const i = Math.min(index, maxIndex());
        index = i;
        track.style.transform = `translateX(${-i * step()}px)`;
      };
      qs('[data-pdp-pair-prev]', root)?.addEventListener('click', () => {
        index = Math.max(0, index - 1);
        render();
      });
      qs('[data-pdp-pair-next]', root)?.addEventListener('click', () => {
        index = Math.min(maxIndex(), index + 1);
        render();
      });
      window.addEventListener('resize', render);
    });
  }

  /* Mobile Select Size — closed dropdown that expands (mockup 414) */
  function initMobileSizeDropdown() {
    const mq = window.matchMedia('(max-width: 767.98px)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const DURATION = 280;

    const clearListAnim = (list) => {
      list.style.height = '';
      list.style.overflow = '';
      list.style.transition = '';
      if (list._pdpDdFinish) {
        list.removeEventListener('transitionend', list._pdpDdFinish);
        clearTimeout(list._pdpDdTimer);
        list._pdpDdFinish = null;
        list._pdpDdTimer = null;
      }
    };

    const setOpen = (list, open) => {
      if (!mq.matches) {
        list.classList.remove('is-open');
        clearListAnim(list);
        return;
      }

      if (reduceMotion) {
        clearListAnim(list);
        list.classList.toggle('is-open', open);
        return;
      }

      if (!!list.classList.contains('is-open') === !!open) return;

      clearListAnim(list);

      const from = list.getBoundingClientRect().height;
      list.classList.toggle('is-open', open);
      list.style.height = 'auto';
      list.style.overflow = 'hidden';
      const to = list.getBoundingClientRect().height;

      list.style.transition = 'none';
      list.style.height = `${from}px`;
      list.getBoundingClientRect();

      let done = false;
      const finish = (e) => {
        if (done) return;
        if (e && e.target !== list) return;
        if (e && e.propertyName && e.propertyName !== 'height') return;
        done = true;
        clearListAnim(list);
      };
      list._pdpDdFinish = finish;

      requestAnimationFrame(() => {
        list.style.transition = `height ${DURATION}ms ease`;
        list.style.height = `${to}px`;
      });

      list.addEventListener('transitionend', finish);
      list._pdpDdTimer = window.setTimeout(finish, DURATION + 80);
    };

    qsa('.pdp-variant-list').forEach((list) => {
      if (list.dataset.pdpSizeDd === '1') return;
      list.dataset.pdpSizeDd = '1';
      list.classList.add('pdp-size-dd');

      list.addEventListener('click', (e) => {
        if (!mq.matches) return;
        const label = e.target.closest('.pdp-opt');
        if (!label) return;
        const input = label.previousElementSibling;
        const isSelected = input && input.checked;

        if (!list.classList.contains('is-open')) {
          e.preventDefault();
          setOpen(list, true);
          return;
        }

        if (isSelected) {
          e.preventDefault();
          setOpen(list, false);
          return;
        }

        // Let radio change, then collapse
        requestAnimationFrame(() => setOpen(list, false));
      });

      document.addEventListener('click', (e) => {
        if (!mq.matches || !list.classList.contains('is-open')) return;
        if (!list.contains(e.target)) setOpen(list, false);
      });
    });

    const sync = () => {
      if (!mq.matches) {
        qsa('.pdp-size-dd.is-open').forEach((el) => {
          el.classList.remove('is-open');
          clearListAnim(el);
        });
      }
    };
    mq.addEventListener?.('change', sync);
    window.addEventListener('resize', sync);
  }

  function initDeliveryDateGuard() {
    const widget = document.querySelector('[data-pdp-date-widget]');
    if (!widget || widget.dataset.pdpDateGuard === '1') return;
    widget.dataset.pdpDateGuard = '1';

    const infoHtml = `
      <span class="pdp-date-info tooltip" tabindex="0" role="button" aria-label="Shipping information">
        <span class="pdp-date-info__icon" aria-hidden="true">i</span>
        <span class="tooltiptext tooltip_text">
          <strong class="pdp-date-info__title">Shipping Information</strong>
          <span class="pdp-date-info__body">
            All orders include free shipping direct from the farm by FedEx ensuring maximum freshness.
          </span>
        </span>
      </span>
    `;

    const ensureInfoIcon = () => {
      const box = document.getElementById('datepicker_box');
      if (!box) return;
      if (box.querySelector('.pdp-date-info')) return;

      let label =
        box.querySelector('.pdp-date-label label') ||
        box.querySelector('label[for="delivery-date-pro"]') ||
        box.querySelector('.date-box label');
      if (!label) return;

      let row = label.closest('.pdp-date-label');
      if (!row) {
        row = document.createElement('div');
        row.className = 'pdp-date-label';
        label.parentNode.insertBefore(row, label);
        row.appendChild(label);
      }

      // Drop legacy floated tooltip/img if present outside the label row.
      box.querySelectorAll('.date-box > .tooltip, .date-box > .pdp-date-info').forEach((el) => {
        if (!row.contains(el)) el.remove();
      });

      if (!row.querySelector('.pdp-date-info')) {
        row.insertAdjacentHTML('beforeend', infoHtml);
      }
    };

    const ensureVisible = () => {
      const box = document.getElementById('datepicker_box');
      const input = document.getElementById('delivery-date-pro');
      if (box) {
        box.style.setProperty('display', 'block', 'important');
        box.style.setProperty('visibility', 'visible', 'important');
        box.style.setProperty('opacity', '1', 'important');
      }
      if (input) {
        input.disabled = false;
        input.removeAttribute('disabled');
        input.style.setProperty('display', 'block', 'important');
        input.style.setProperty('visibility', 'visible', 'important');
        input.style.setProperty('opacity', '1', 'important');
      }
      ensureInfoIcon();
    };

    const restoreFallback = () => {
      if (document.getElementById('datepicker_box') || document.getElementById('delivery-date-pro')) {
        ensureVisible();
        return;
      }

      // Zestard removes #datepicker_box when product settings are missing/inactive.
      // Keep a mockup-matching date field so the widget + hint both remain visible.
      const wrap = document.createElement('div');
      wrap.id = 'datepicker_box';
      wrap.className = 'additional-css pdp-date-fallback-wrap';
      wrap.innerHTML = `
        <div class="date-box">
          <div class="pdp-date-label">
            <label for="delivery-date-pro">Select Delivery Date</label>
            ${infoHtml}
          </div>
          <input
            id="delivery-date-pro"
            class="pdp-date-input pdp-date-fallback"
            type="date"
            name="properties[Delivery-Date]"
            required
          >
        </div>
      `;
      widget.appendChild(wrap);
      ensureVisible();
    };

    ensureVisible();

    const observer = new MutationObserver(() => {
      ensureVisible();
      if (!document.getElementById('datepicker_box') && !document.getElementById('delivery-date-pro')) {
        // Defer restore slightly so we don't fight Zestard's own DOM setup.
        clearTimeout(widget._pdpDateRestoreTimer);
        widget._pdpDateRestoreTimer = setTimeout(restoreFallback, 50);
      }
    });
    observer.observe(widget, { childList: true, subtree: true });

    [200, 800, 1600, 3000, 5000].forEach((ms) => {
      setTimeout(() => {
        ensureVisible();
        restoreFallback();
      }, ms);
    });
  }

  function initGiftMessageToggles() {
    document.querySelectorAll('[data-pdp-gift-message]').forEach((wrap) => {
      if (wrap.dataset.giftBound === '1') return;
      wrap.dataset.giftBound = '1';

      const toggle = wrap.querySelector('.hid_show');
      const panel = wrap.querySelector('.option-selector');
      const textarea = wrap.querySelector('textarea.custom-option__text-input');
      const switchWrap = wrap.querySelector('.switch-wrap');
      if (!toggle || !panel || !textarea) return;

      const sync = () => {
        const on = !!toggle.checked;
        panel.classList.toggle('is-open', on);
        // Theme jQuery also toggles display on .hid_show click — keep ours authoritative.
        panel.style.display = on ? 'block' : 'none';
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
        textarea.disabled = !on;
        toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (switchWrap) switchWrap.classList.toggle('is-on', on);
        // Match legacy: only push the property when the toggle is on.
        if (!on) textarea.value = '';
      };

      // Block legacy theme $(".hid_show").click → .toggle() so it can't hide the panel.
      toggle.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
        },
        true
      );

      toggle.addEventListener('change', sync);
      sync();
    });
  }

  function init() {
    initModals();
    initQuotes();
    initGuideTabs();
    initAccordions();
    initPairCarousel();
    initMobileSizeDropdown();
    initDeliveryDateGuard();
    initGiftMessageToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
